import '../pages/LandingPage.css';
import Icon_Group from '../assets/Icon Group.svg';
import Bar from '../assets/Bar.svg';
import { Link, useNavigate } from 'react-router-dom';
import Layout from './Layout';

function ShouldCost({ username, onSignOut }) {

    const navigate = useNavigate();

    const handleClick = (query) => {
        navigate("/ShouldChatbot", { state: query });
    };

    return (
        <Layout username={username} onSignOut={onSignOut}>
            <div className="container-fluid Home">
                <div className='row'>
                    <div className="SummaryBreadCrumb border-b-[1px] border-[#CFCFCF] gap-2">
                        <Link to="/">
                            <span className="SummaryBreadCrumbInside cursor-pointer hover:text-black">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                    <path d="M8.33464 17.4538V12.4538H11.668V17.4538H15.8346V10.7871H18.3346L10.0013 3.28711L1.66797 10.7871H4.16797V17.4538H8.33464Z" />
                                </svg>
                                <span className="SummaryText">Home</span>
                            </span>
                        </Link>
                        <span>/</span>
                        <Link to="/LandingPage">
                            <span className="SummaryBreadCrumbInside hover:text-black cursor-pointer" >Should Cost Modeling</span>
                        </Link>
                        <span>/</span>
                        <span className="HomeText">Should Cost Simplified</span>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-1'></div>
                    <div className='col-10'>
                        <div className='chatbot-screen w-full'>
                            <div className='w-full'>
                                <div className='chatbot-heading pt-5'>
                                    <div>Should Cost Simplified. Let's Begin.</div>
                                </div>
                                <div className='chatbot-progressBar pt-4'>
                                    <div className='chatbot-barHeading'>
                                        <img src={Bar} alt="Bar" className="Bar" />
                                        <div className='chatbot-iconGroup'>
                                            <img src={Icon_Group} alt="Icon_Group" className="Icon_Group" />
                                            <span className='chatbot-text'>Fetch Specifications​</span>
                                        </div>
                                    </div>
                                    <div className='chatbot-barHeading'>
                                        <img src={Bar} alt="Bar" className="Bar" />
                                        <div className='chatbot-iconGroup'>
                                            <img src={Icon_Group} alt="Icon_Group" className="Icon_Group" />
                                            <span className='chatbot-text'>Should cost​​</span>
                                        </div>
                                    </div>
                                    <div className='chatbot-barHeading'>
                                        <img src={Bar} alt="Bar" className="Bar" />
                                        <div className='chatbot-iconGroup'>
                                            <img src={Icon_Group} alt="Icon_Group" className="Icon_Group" />
                                            <span className='chatbot-text'>Cost Breakdown​​</span>
                                        </div>
                                    </div>

                                    <div className='chatbot-barHeading'>
                                        <img src={Bar} alt="Bar" className="Bar" />
                                        <div className='chatbot-iconGroup'>
                                            <img src={Icon_Group} alt="Icon_Group" className="Icon_Group" />
                                            <span className='chatbot-text'>What if Analysis​​</span>
                                        </div>
                                    </div>
                                    <div className='chatbot-barHeading'>
                                        <img src={Bar} alt="Bar" className="Bar" />
                                        <div className='chatbot-iconGroup'>
                                            <img src={Icon_Group} alt="Icon_Group" className="Icon_Group" />
                                            <span className='chatbot-text'>Negotiation Assist​​</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-1'></div>
                    <div className='col-10 flex justify-center'>
                        <div className='pt-10 pb-3 text-[#000000] font-semibold text-[14px]'>
                            <span>Please select an option to proceed</span>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-1'></div>
                    <div className='col-10 justify-center gap-2 flex-wrap flex items-center'>
                        <div className='LandingSearchBar-types w-1/4 cursor-pointer hover:bg-[#e4d4ff] transition' onClick={() => handleClick('Create should cost for one part')}>
                            <span className='LandingSearchBar-typesHeading'>Create should cost for one part</span>
                            <span className='subcatrgory'>
                                A guided, step by step approach for should costing for one part at a time
                            </span>
                        </div>
                        <div className='LandingSearchBar-types w-1/4 cursor-pointer hover:bg-[#e4d4ff] transition' onClick={() => handleClick('Create should cost for multiple parts')}>
                            <span className='LandingSearchBar-typesHeading'>Create should cost for multiple parts</span>
                            <span className='subcatrgory'>
                                Run batch should-costing for multiple parts simultaneously.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}
export default ShouldCost;